import { useQuery, QueryFunction } from "react-query";
import { AxiosError } from "axios";

import { fetchNotifications } from "modules/core/api/notifications";

import { INotificationsResponse } from "modules/core/types/res";

export const NOTIFICATIONS_QUERY_KEY = "/notifications";

export type NotificationsQueryKey = [ string ];

const queryFn: QueryFunction<INotificationsResponse, NotificationsQueryKey> =
  async () => {

    return await fetchNotifications();
  };

export const useNotificationsQuery = (options = {}) => {
  const queryResults = useQuery<
    INotificationsResponse,
    AxiosError,
    INotificationsResponse,
    NotificationsQueryKey
    >(
      [NOTIFICATIONS_QUERY_KEY], queryFn, {
      staleTime: 1 * 60 * 1000,
      refetchInterval: 1 * 60 * 1000,
      refetchIntervalInBackground: true,
      placeholderData: [],
      ...options
  });

  return queryResults;
};


